import { programsApi } from "./api/program.api";

export interface PoolSuggestions {
    courseIds: string[];
    /** 课号 → 挂靠 requirement ids(any_of 来源为空数组、match 池恒空) */
    courseRequirements: Record<string, string[]>;
}

/**
 * Pool 推荐课的会话级缓存,keyed by `programId::poolKey`。
 * 口径与 requirementSuggestions 相同:结果与 program 结构无关,后端已按
 * query hash 跨用户缓存,前端只在会话内去重;登录用户的响应已减去其已有课,
 * 会话内新增课由消费方按最新 userCourses 再过滤,不重拉。
 * 身份切换时须清空(排除口径随用户变),挂在 sliceCacheIdentity 的同一时机。
 */
const cache = new Map<string, PoolSuggestions>();
const inflight = new Map<string, Promise<PoolSuggestions>>();

export function getPoolSuggestions(
    programId: string,
    poolKey: string,
): Promise<PoolSuggestions> {
    const key = `${programId}::${poolKey}`;
    const cached = cache.get(key);
    if (cached) return Promise.resolve(cached);
    const pending = inflight.get(key);
    if (pending) return pending;

    const request = programsApi
        .getPoolSuggestions(programId, poolKey)
        .then(result => {
            const suggestions: PoolSuggestions = {
                courseIds: result.courseIds,
                courseRequirements: result.courseRequirements,
            };
            cache.set(key, suggestions);
            return suggestions;
        })
        .finally(() => {
            inflight.delete(key);
        });
    inflight.set(key, request);
    return request;
}

/** 身份切换 / 结构失效时调用 */
export function clearPoolSuggestions(): void {
    cache.clear();
}
